import { Step } from 'signup-constants/Step';
import { FlowStateManager } from '../flow-management/FlowStateManager';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { setFlowForACQ149 } from '../experiments/acq149/ACQ149Utils';
import { trackACQ149ExposureForGooglePrompt } from '../experiments/acq149/acq149Tracking';
import { setFlowForACQ155, trackACQ155ExposureForGooglePrompt } from '../experiments/acq0155/ACQ155Utils';
import { setFlowForCOAC0002, trackCOAC0002ExposureForGooglePrompt } from '../experiments/coac0002/COAC0002Utils';
export const setFlowAfterGoogleCredentialAuthentication = response => (dispatch, getState) => {
  const state = getState();
  const isEnrolledACQ0149Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0149, [ExperimentParameterGroup.Variant_A]);
  const isEnrolledACQ0155Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0155, [ExperimentParameterGroup.Variant_A]);
  const isEnrolledCOAC0002Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.COAC0002, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B]);
  const stepsToRemove = [...(response.email ? [Step.LandingPage] : []), Step.Verification, Step.CodeVerification, Step.Password, ...(response.firstName && response.lastName ? [Step.Name] : [])];
  if (isEnrolledACQ0149Variant) {
    dispatch(setFlowForACQ149({
      stepsToRemove
    }));
  } else if (isEnrolledACQ0155Variant) {
    dispatch(setFlowForACQ155({
      stepsToRemove: [Step.HubletSelection, ...stepsToRemove]
    }));
  } else if (isEnrolledCOAC0002Variant) {
    dispatch(setFlowForCOAC0002({
      stepsToRemove
    }));
  } else {
    dispatch(FlowStateManager.removeSteps(stepsToRemove));
  }
  trackACQ149ExposureForGooglePrompt(state);
  trackACQ155ExposureForGooglePrompt(state);
  trackCOAC0002ExposureForGooglePrompt(state);
};